import classNames from 'classnames';
import * as React from 'react';
import type { RestrictedSingleSubject } from '../../Interfaces/RestrictedSingleSubject';
import { SingleSubject } from '../SingleSubject/SingleSubject';
import type { SingleSubjectActionDisplayType } from '../SingleSubject/SingleSubjectAction/SingleSubjectActionDisplayType';
import type { SingleSubjectDisplayType } from '../SingleSubject/SingleSubjectDisplayType';
import { List } from '~/Partials/List/List';
import styles from './SubjectList.module.css';
import type { SubjectsListSize } from './SubjectListSize';

export interface SubjectListProps {
    subjects: RestrictedSingleSubject[];
    onSubjectActionClick: (subject: RestrictedSingleSubject) => void;
    isSubjectSelected: (subject: RestrictedSingleSubject) => boolean;
    isSubjectDisabled?: (subject: RestrictedSingleSubject) => boolean;
    size?: SubjectsListSize;
    subjectDisplayType?: SingleSubjectDisplayType;
    subjectActionDisplayType?: SingleSubjectActionDisplayType;
    className?: string;
}

export const SubjectList: React.FC<SubjectListProps> = props => {
    const {
        subjects,
        onSubjectActionClick,
        subjectActionDisplayType,
        subjectDisplayType,
        className,
        isSubjectSelected,
        isSubjectDisabled = () => false,
        size = 'default',
    } = props;

    const subjectSize = size === 'compact' ? 'small' : 'normal';

    return (
        <List
            className={classNames(styles.SubjectList, styles[`Variant--${size}`], className)}
            items={subjects}
            renderItem={subject => (
                <li className={styles.SubjectListItem} key={subject.subjectCode}>
                    <SingleSubject
                        {...subject}
                        actionDisplayType={subjectActionDisplayType}
                        displayType={subjectDisplayType}
                        size={subjectSize}
                        isSelected={isSubjectSelected(subject)}
                        isDisabled={isSubjectDisabled(subject)}
                        onActionClick={() => onSubjectActionClick(subject)}
                    />
                </li>
            )}
        />
    );
};
